import script from "./RootDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./RootDetail.vue?vue&type=script&setup=true&lang=js"

import "./RootDetail.vue?vue&type=style&index=0&id=2914985a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2914985a"]])

export default __exports__